export default __webpack_public_path__ + "static/media/sun-1.db4c6eee.png";